/** @jsx jsx */
import { Fragment } from 'react'
import { jsx } from '@emotion/core'

import { LoadingSurveys, SurveysList } from './'

const LoadingSurveysList = ({ showTemplates }) => {
  return (
    <Fragment>
      {showTemplates && (
        <SurveysList label="Weekly Templates">
          <LoadingSurveys />
        </SurveysList>
      )}

      <SurveysList>
        <LoadingSurveys />
      </SurveysList>
    </Fragment>
  )
}

export default LoadingSurveysList
